/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Input,
  Modal,
  message,
  TreeSelect,
  DatePicker,
} from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalDelete from 'components/ModalDelete';
import ModalConfirmation from 'components/ModalConfirmation';
import Select from 'components/Select';
import API from 'utils/api';
import {
  getCOGS, getCuentasContables, getEstadosGlobales, getFuentesDeFinanciamiento, getTipoDeGasto,
} from 'api/catalogos/index';

// APIs del recurso (creadas antes)
import {
  getPercepcionesParametrosDiversos,
  postPercepcionParametroDiverso,
  deletePercepcionParametroDiverso,
  patchPercepcionParametroDiverso,
  getPercepcionParametroDiverso,
  autorizarPercepcionParametroDiverso,
} from 'api/PercepcionesParametrosDiversos.api';

import { checkToken } from 'api/utils';
import {
  ESTATUS_ACTIVO,
  ESTATUS_INACTIVO,
  ESTATUS_AUTORIZADO,
} from 'utils/constants';
import { getCATSATOrigenesRecursos } from 'api/nominas/catalogos/CATSATOrigenesRecursos';
import { getTiposDeEmpleadosPresupuestales } from 'api/catalogos/tiposDeEmpleadosPresupuestales';
import makeTree from 'utils/makeTree';
import { getClasificadoresObjetoGastoUnion } from 'api/configuraciones/clasificadorObjetoGasto';
import makeTreeFromCuentasContables from 'utils/makeTreeFromCuentasContables';
import AreasContablesTabla from './AreasContablesTabla';

export const percepcionesParametrosDiversosPermission = {
  permissionModel: 'percepcionparametrodiverso',
  catalogsModels: [],
  tabsModels: [],
};

const PercepcionesParametrosDiversos = ({
  permission, percepcionId, onCheckAplicaContable, onRowSelected,
  esPagoDescuentoIndebido = false,
}) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [visibleConfirmInactivo, setVisibleConfirmInactivo] = useState(false);
  const [disableFields, setDisableFields] = useState(false);
  const [aplicaContable, setAplicaContable] = useState(false);

  // catálogos locales
  const [cogs, setCogs] = useState([]);
  const [fuentesFinanciamiento, setFuentesFinanciamiento] = useState([]);
  const [cuentasContables, setCuentasContables] = useState([]);
  const [tiposGasto, setTiposGasto] = useState([]);
  const [origenesSAT, setOrigenesSAT] = useState([]);
  const [tiposEmpleado, setTiposEmpleado] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [simpleData, setSimpleData] = useState([]);
  const [listaFuentes, setListaFuentes] = useState([]);

  const formInstances = [form];

  const onClickTitle = (e) => {
    const element = e.target;
    if (element) {
      let parent = element.parentElement;
      parent = parent ? parent.parentElement : null;
      if (parent) {
        const clickableSpan = parent.previousSibling;
        if (clickableSpan) {
          clickableSpan.click();
        }
      }
    }
  };
  const buildTreeData = (_data) => {
    const map = {};
    const roots = [];

    data.forEach((item) => {
      map[item.id] = {
        title: `${item.clave} - ${item.concepto}`,
        value: item.clave_padre_id ? `${data.find((x) => x.id === item.clave_padre_id)?.clave}/${item.id}` : `${item.id}`,
        key: item.clave_padre_id ? `${data.find((x) => x.id === item.clave_padre_id)?.clave}/${item.id}` : `${item.id}`,
        children: [],
        ...item,
      };
    });

    data.forEach((item) => {
      if (item.clave_padre_id && map[item.clave_padre_id]) {
        map[item.clave_padre_id].children.push(map[item.id]);
      } else {
        roots.push(map[item.id]);
      }
    });

    return roots;
  };
  // Extrae solo el ID del valor "clave/id"
  const getCogId = (val) => Number(String(val).split('/').pop());

  // Encuentra el .value del nodo del árbol dado un ID
  const getTreeValueById = (tree, id) => {
    const stack = [...tree];
    while (stack.length) {
      const node = stack.pop();
      if (getCogId(node?.value) === id) return node.value;
      if (node.children?.length) stack.push(...node.children);
    }
    return undefined;
  };

  const renderTitle = (title, bold) => (
    // eslint-disable-next-line
    <span onClick={onClickTitle} className={bold ? 'bold' : ''}>
      {title}
    </span>
  );

  const normalizeCuentasContables = (_data) => {
    if (_data) {
      return _data.map((item) => {
        const clone = { ...item };
        const children = normalizeCuentasContables(clone.children);

        //  Solo es seleccionable si es tipo === 7 (afectable)
        const isAfectable = clone.tipo === 7;

        // Si no tiene hijos, lo evaluamos como hoja
        const isLeaf = !children.length;

        //  Solo habilitamos selección si es hoja y afectable
        const selectable = isLeaf && isAfectable;

        if (!isLeaf) {
          delete clone.children;
        }

        return {
          ...clone,
          title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
          value: clone.id,
          key: clone.id,
          children: children.length ? children : undefined,
          disabled: !selectable, //  Solo se puede seleccionar si cumple la condición
        };
      });
    }
    return [];
  };

  const normalizeTreeCog = (_data) => {
    const idMap = {};
    const allNodes = [];

    _data.forEach((item) => {
      const clone = { ...item };
      const title = `${clone.clave} - ${clone.concepto}`;
      clone.title = renderTitle(title);

      // --- CAMBIO IMPORTANTE ---
      // Usamos CLAVE para que el árbol visual sea único
      clone.key = clone.clave;
      clone.value = clone.clave;
      // -------------------------

      clone.disabled = clone.seleccionable === false;
      clone.children = [];

      allNodes.push(clone);

      // Mapeamos por ID para poder armar la jerarquía de padres
      if (!idMap[clone.id]) {
        idMap[clone.id] = clone;
      }
    });

    const rootNodes = [];

    // Armamos la jerarquía
    allNodes.forEach((node) => {
      if (node.clave_padre_id) {
        const padre = idMap[node.clave_padre_id];
        // Solo agregamos si encontramos al padre
        if (padre) {
          padre.children.push(node);
        } else {
          rootNodes.push(node);
        }
      } else {
        rootNodes.push(node);
      }
    });

    // Limpieza visual
    Object.keys(idMap).forEach((key) => {
      const node = idMap[key];
      if (node.children && node.children.length === 0) {
        node.children = undefined;
      }
    });

    return rootNodes;
  };

  const disableNivel4Nodes = (nodes, nivel = 1) => nodes.map((node) => {
    const newNode = { ...node };
    if (nivel === 4) {
      newNode.disabled = true;
    }
    if (newNode.children) {
      newNode.children = disableNivel4Nodes(newNode.children, nivel + 1);
    }
    return newNode;
  });
  const normalizeSimpleData = (_data) => {
    const result = [];
    const processNode = (node) => {
      const copy = { ...node };
      result.push(copy);
      if (copy.children && copy.children.length) {
        copy.children.forEach((child) => {
          processNode(child);
        });
      }
      copy.children = undefined;
    };
    _data.forEach(processNode);
    return result;
  };

  const normalize = (_data = [], level = 0, visited = new Set()) => _data.map((item, index) => {
    const clone = { ...item };
    const uniqueId = clone.id ?? clone.clave;

    if (visited.has(uniqueId)) {
      return null;
    }

    visited.add(uniqueId);

    const children = Array.isArray(clone.children)
      ? normalize(clone.children, level + 1, new Set(visited))
      : [];

    return {
      ...clone,
      key: clone.id,
      value: clone.id,
      title: renderTitle(`${clone.clave} - ${clone.nombre}`, children.length > 0),
      disabled: item.seleccionable === false,
      children: children.length ? children : undefined,
    };
  }).filter(Boolean);

  const formatDataTree = (_data = [], excludeLvl3 = false, currLvl = 1) => _data.map((item) => {
    const clone = { ...item };

    const children = formatDataTree(
      !excludeLvl3 || currLvl !== 2 ? clone.children || [] : [],
      excludeLvl3,
      currLvl + 1,
    );

    const node = {
      key: clone.key || clone.id?.toString(),
      value: clone.value || clone.id?.toString(),
      title: clone.title,
      disabled: !clone.seleccionable,
      children, // mantener siempre
    };

    return node;
  });
  const fetchData = async () => {
    setLoading(true);
    const params = {};
    if (percepcionId) params.percepcion = percepcionId;
    const _data = await getPercepcionesParametrosDiversos(params);
    setData(formatReceived(_data));
    // 1. Guardamos el resultado formateado en una variable
    const datosFormateados = formatReceived(_data);

    // 2. Usamos esa variable para el estado local
    setData(datosFormateados);

    // 3. Usamos la misma variable para avisar al padre (si existe la función)
    if (onCheckAplicaContable) {
      onCheckAplicaContable(datosFormateados);
    }
    setLoading(false);
  };

  const findInTree = (nodes, id) => {
    if (!Array.isArray(nodes)) return null;

    return nodes.reduce((found, node) => {
      if (found) return found;

      if (node.id === id) {
        return node;
      }

      if (node.children) {
        return findInTree(node.children, id) || found;
      }

      return found;
    }, null);
  };

  useEffect(() => {
    let mounted = true;

    const fetchAll = async () => {
      setLoading(true);
      try {
        await checkToken();

        // Definimos las promesas base de los catálogos que siempre se necesitan
        const promises = [
          getEstadosGlobales(),
          getCOGS(),
          getFuentesDeFinanciamiento(),
          getTipoDeGasto(),
          getCATSATOrigenesRecursos(),
          getTiposDeEmpleadosPresupuestales(),
          getCuentasContables(),
          getClasificadoresObjetoGastoUnion(),
        ];

        // SOLO si existe percepcionId, agregamos la promesa para traer los registros hijos
        // Si no existe, usamos una promesa que devuelva un arreglo vacío
        const dataPromise = percepcionId
          ? getPercepcionesParametrosDiversos({ percepcion: percepcionId })
          : Promise.resolve([]);

        const [
          _estados,
          _cogs,
          _fuentesFinanciamiento,
          _tiposGasto,
          _origenesSAT,
          _tiposEmpleado,
          _cuentasContables,
          _dataUnion,
          _data, // Este será [] si no hay percepcionId
        ] = await Promise.all([...promises, dataPromise]);

        if (!mounted) return;

        // Seteo de catálogos y estructuras de árboles
        const formattedDataUnion = normalizeTreeCog(_dataUnion);
        const _simpleData = normalizeSimpleData(formattedDataUnion);

        setEstados(_estados);
        setCogs(_cogs);
        setSimpleData(_simpleData);
        setTreeData(formattedDataUnion);
        setTiposGasto(_tiposGasto);
        setOrigenesSAT(_origenesSAT);
        setTiposEmpleado(_tiposEmpleado);

        // Seteo de la data de la tabla (Estará vacía si es un registro nuevo)
        const formattedTableData = formatReceived(_data);
        setData(formattedTableData);

        // Notificar al padre sobre la existencia de registros contables
        if (onCheckAplicaContable) {
          onCheckAplicaContable(formattedTableData);
        }

        // Carga de fuentes de financiamiento desde API directamente
        const response = await API.get('contabilidad/clasificaciones-de-fuentes-de-financiamiento/');
        setListaFuentes(response.data);
        const fuentesFTree = makeTree(response.data);
        const normalized = normalize(fuentesFTree);
        setFuentesFinanciamiento(formatDataTree(normalized));

        // eslint-disable-next-line max-len
        const normalizedCuentas = normalizeCuentasContables(makeTreeFromCuentasContables(_cuentasContables));
        setCuentasContables(normalizedCuentas);
      } catch (err) {
        message.error('Error cargando la información');
      } finally {
        if (mounted) setLoading(false);
      }
    };

    fetchAll();

    return () => {
      mounted = false;
    };
  }, [percepcionId]); // Se vuelve a ejecutar cuando el padre obtiene un ID al guardar
  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    setDisableFields(false);
    setSelectedRowKeys([]);
    setSelectedData({});
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _item = await getPercepcionParametroDiverso(match.id);

    setTimeout(() => {
      if (_item) {
        form.resetFields();
        const values = formatReceived(_item);

        // --- SOLUCIÓN DE ID DUPLICADO ---
        if (values.cog) {
          // Filtramos todos los que tengan ese ID (Ej. ID 1 devuelve [1000, 1111])
          const candidatos = simpleData.filter((e) => e.id === values.cog);

          // Priorizamos el que sea 'seleccionable' (El hijo: 1111)
          const seleccionado = candidatos.find((e) => e.seleccionable === true);

          // Si no hay seleccionable, usamos el primero que encontremos como fallback
          const finalMatch = seleccionado || candidatos[0];

          if (finalMatch) {
            // Asignamos la CLAVE ("1111") al formulario para que el TreeSelect lo reconozca
            values.cog = finalMatch.clave;
          }
        }
        setTimeout(() => {
          form.setFieldsValue(values);
          setAplicaContable(_item.aplica_cuenta_contable_por_area);
          const estadoId = _item?.estados_globales?.id ?? _item?.estados_globales;
          setDisableFields(estadoId !== ESTATUS_ACTIVO);
          setVisible(true);
        });
      }
    });

    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();

      if (values.cog) {
        const cogReal = simpleData.find((e) => e.clave === values.cog);
        if (cogReal) {
          values.cog = cogReal.id;
        }
      }

      const nullableFKs = [
        'cog', 'fuente_financiamiento', 'tipo_de_gasto',
        'tipo_empleado_presupuestal', 'catsat_origen_recurso',
      ];
      nullableFKs.forEach((field) => {
        if (values[field] === undefined) {
          values[field] = null;
        }
      });

      if (typeof values.estados_globales === 'object') {
        values.estados_globales = values.estados_globales.id;
      }

      // asegurar que venga la percepcion
      if (percepcionId) values.percepcion = percepcionId;
      if (values.vigencia_final) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }
      //
      const [key] = selectedRowKeys;

      const saved = await (key
        ? patchPercepcionParametroDiverso(key, values)
        : postPercepcionParametroDiverso(values));

      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading, formInstances);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deletePercepcionParametroDiverso(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
    if (onRowSelected) {
      onRowSelected(record);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    form.resetFields();
    setAplicaContable(false);
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    const [key] = selectedRowKeys;
    if (key) {
      setVisibleAlert(true);
    } else {
      setVisibleAlert(false);
      message.warn('Este campo no se puede borrar');
    }
  };

  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un registro ya autorizado');
        return;
      }
      const saved = await autorizarPercepcionParametroDiverso(key);
      if (saved) {
        // eslint-disable-next-line max-len
        const _data = await getPercepcionesParametrosDiversos(percepcionId ? { percepcion: percepcionId } : {});
        setData(formatReceived(_data));
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const columns = [
    {
      titleText: 'Clasificador por Objeto del Gasto (COG)',
      dataIndex: 'cog',
      key: 'cog',
      width: 400,
      render: (val, record) => {
        // 1. PRIMER INTENTO: Buscar por CLAVE (ej. "1111")
        // Esto es lo ideal si el registro ya trae la clave guardada
        if (record.clave) {
          const matchPorClave = simpleData.find((e) => e.clave === record.clave);
          if (matchPorClave) {
            return `${matchPorClave.clave} - ${matchPorClave.concepto}`;
          }
        }

        // 2. FALLBACK MEJORADO: Buscar por ID resolviendo duplicados
        // Buscamos TODOS los registros que tengan este ID (ej. ID 1 traerá [1000, 1111])
        const candidatos = simpleData.filter((e) => e.id === val);

        if (candidatos.length > 0) {
          // "Desempate": Priorizamos el que sea seleccionable (el hijo: 1111) sobre el padre (1000)
          const ganador = candidatos.find((e) => e.seleccionable === true) || candidatos[0];
          return `${ganador.clave} - ${ganador.concepto}`;
        }

        // 3. ÚLTIMO RECURSO: Buscar en el catálogo cogs original (por si acaso)
        const matchCogs = cogs.find((e) => e.id === val);
        return (matchCogs?.clave ? `${matchCogs.clave} - ${matchCogs.concepto}` : val);
      },
    },
    {
      titleText: 'Fuente Financiamiento',
      dataIndex: 'fuente_financiamiento',
      key: 'fuente_financiamiento',
      width: 200,
      render: (val) => {
        const fuente = listaFuentes.find((f) => f.id === val);
        return fuente ? `${fuente.clave} - ${fuente.nombre}` : val;
      },
    },
    {
      titleText: 'Es Fuente de Financiamiento Principal',
      dataIndex: 'es_fuente_de_financiamiento_principal',
      key: 'es_fuente_de_financiamiento_principal',
      width: 200,
      render: (val) => (val ? 'Sí' : 'No'),
    },
    {
      titleText: 'Tipo de Gasto',
      dataIndex: 'tipo_de_gasto',
      key: 'tipo_de_gasto',
      width: 400,
      render: (val) => {
        const _tipoDeGasto = tiposGasto.find((e) => e.id === val);
        return (_tipoDeGasto?.clave ? `${_tipoDeGasto?.clave} - ${_tipoDeGasto?.nombre}` : '');
      },
    },
    {
      titleText: 'Origen Recurso',
      dataIndex: 'catsat_origen_recurso',
      key: 'catsat_origen_recurso',
      width: 220,
      render: (val) => origenesSAT.find((o) => o.id === val)?.descripcion || val,
    },
    {
      titleText: 'Tipo de Empleado Presupuestal',
      dataIndex: 'tipo_empleado_presupuestal',
      key: 'tipo_empleado_presupuestal',
      width: 220,
      render: (val) => tiposEmpleado.find((t) => t.id === val)?.descripcion || val,
    },
    {
      titleText: 'Cuenta Contable',
      dataIndex: 'cuenta_contable',
      key: 'cuenta_contable',
      width: 400,
      render: (val) => {
        const _cuentasContables = findInTree(cuentasContables, val);

        return _cuentasContables
          ? `${_cuentasContables.clave_visible || _cuentasContables.clave} - ${_cuentasContables.nombre}`
          : val;
      },
    },
    {
      titleText: 'Registro Adicional',
      dataIndex: 'registro_adicional',
      key: 'registro_adicional',
      width: 150,
    },
    {
      titleText: 'Aplica Cuenta Contable por Área',
      dataIndex: 'aplica_cuenta_contable_por_area',
      key: 'aplica_cuenta_contable_por_area',
      width: 200,
      render: (val) => (val ? 'Sí' : 'No'),
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 200,
      render: (vigencia) => (vigencia ? new Date(vigencia).toLocaleDateString() : 'Sin fecha'),

    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 150,
      render: (val) => val?.descripcion
        || estados.find((e) => e.id === val)?.descripcion
        || '',
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd: percepcionId ? onClickAdd : undefined,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          customActions={[
            {
              onClick: () => setVisibleAutorizar(true),
              permission: { model: 'percepcionparametrodiverso', action: 'autorizar' },
              icon: <CheckCircleOutlined />,
              text: 'Autorizar',
              disabledBySelection: true,
              disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
              className: 'success',
            },
          ]}
          disableDelete={!percepcionId || selectedData?.estados_globales === ESTATUS_AUTORIZADO}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Parámetro Diverso`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          forceRender
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="percepcion_parametros_diversos"
            onValuesChange={(changedValues) => {
              if ('aplica_cuenta_contable_por_area' in changedValues) {
                setAplicaContable(changedValues.aplica_cuenta_contable_por_area);
                // Si aplica por área, limpiamos la cuenta contable global
                if (changedValues.aplica_cuenta_contable_por_area) {
                  form.setFieldValue('cuenta_contable', undefined);
                }
              }
            }}
            initialValues={{
              estados_globales: ESTATUS_ACTIVO,
              aplica_cuenta_contable_por_area: false,
              es_fuente_de_financiamiento_principal: false,
              vigencia_final: null,
            }}
          >
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="cog" // OJO: Este campo ahora guardará la CLAVE ("1111")
                label="Clasificador por Objeto del Gasto (COG)"
                rules={esPagoDescuentoIndebido ? [] : [requiredRule]}
                hasFeedback
              >
                <TreeSelect
                  showSearch
                  allowClear
                  treeNodeFilterProp="title"
                  treeData={treeData}
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  placeholder="Seleccione una opción"
                  onChange={(claveSeleccionada) => {
                    // Ahora recibimos "1111" (String), no el ID duplicado.

                    // Buscamos en los datos planos por CLAVE
                    const cogEncontrado = simpleData.find((e) => e.clave === claveSeleccionada);

                    if (cogEncontrado) {
                      form.setFieldValue('clave', cogEncontrado.clave);
                      // El TreeSelect actualiza 'cog' automáticamente con la clave
                    } else {
                      form.setFieldValue('clave', undefined);
                    }
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="fuente_financiamiento"
                label="Fuente de Financiamiento"
                rules={esPagoDescuentoIndebido ? [] : [requiredRule]}
                hasFeedback
              >
                <TreeSelect
                  showSearch
                  treeNodeFilterProp="title"
                  style={{ width: '100%' }}
                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                  treeData={fuentesFinanciamiento}
                  allowClear
                // disabled={!afectaPresupuesto || estatusAutorizado || estatusInactivo}
                />

              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="es_fuente_de_financiamiento_principal"
                label="Es Fuente de Financiamiento Principal"
                rules={esPagoDescuentoIndebido ? [] : [requiredRule]}
                hasFeedback
              >
                <Select
                  trueFalse
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="tipo_de_gasto"
                label="Tipo de Gasto"
                rules={esPagoDescuentoIndebido ? [] : [requiredRule]}
                hasFeedback
              >
                <Select
                  labelProp="nombre"
                  keyProp="id"
                  dataSource={tiposGasto}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="catsat_origen_recurso"
                label="Origen del Recurso (SAT)"
                hasFeedback
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={origenesSAT}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="tipo_empleado_presupuestal"
                label="Tipo Empleado Presupuestal"
                hasFeedback
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={tiposEmpleado}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              {!aplicaContable ? (
                <Form.Item
                  name="cuenta_contable"
                  label="Cuenta Contable del Gasto de la Percepción o Reembolso"
                  hasFeedback
                  rules={aplicaContable ? [] : [requiredRule]}
                >

                  <TreeSelect
                    keyProp="clave"
                    labelProp="nombre"
                    showSearch
                    treeNodeFilterProp="title"
                    treeData={cuentasContables}
                    disabled={aplicaContable}
                  />
                </Form.Item>
              ) : (
                <div className="area-accounts-grid">
                  {/* Aquí va el nuevo componente de Tabla Editable */}
                  <AreasContablesTabla
                    parametroDiversoId={selectedData?.id} // <-- ¡Prop Nueva!
                    cuentasContables={cuentasContables}
                    areas={[]}
                    permission={permission}
                  />
                </div>
              )}
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="registro_adicional"
                label="Registro Adicional"
                hasFeedback
              >
                <Input allowClear />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="vigencia_final"
                label="Vigencia Final"
              >
                <DatePicker
                  format="YYYY-MM-DD"
                  style={{ width: '100%' }}

                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="aplica_cuenta_contable_por_area"
                label="Aplica Cuenta Contable por Área"
                rules={[requiredRule]}
                hasFeedback
              >
                <Select
                  trueFalse
                // disabled={disableFields}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                hasFeedback
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estados}
                  disabled
                />
              </Form.Item>
            </Col>

            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>

        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Parámetro Diverso ${form.getFieldValue('registro_adicional') || ''}`}
          loading={loading}
        />

        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle={`Autorizar el Parámetro Diverso ${selectedData?.id}`}
          open={visibleAutorizar}
          loading={loading}
        />

        <ModalConfirmation
          onFinish={() => setVisibleConfirmInactivo(false)}
          ConfirmInactive
          onCancel={() => {
            form.setFieldValue('estados_globales', ESTATUS_ACTIVO);
            setVisibleConfirmInactivo(false);
          }}
          open={visibleConfirmInactivo}
          contentTitle={`Inactivar el Parámetro Diverso ${selectedData?.id}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default PercepcionesParametrosDiversos;
